import React, { useContext, useEffect, useState } from 'react';
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import { withTranslation, Trans } from 'react-i18next';
import Lock from '../../assets/images/graphics/outlook-wizard/Lock.svg';
import Card from '../../assets/images/graphics/outlook-wizard/Card.svg';
import OfficebookingLogo from '../../assets/images/officebooking.svg';
import LanguageSwitch from './LanguageSwitch';

function OutlookWizard(props) {

    const [step, setStep] = useState(0);

    // Check Office Storage Wizard cookie and show/hide accordingly
    const officeSettingShow = Office.context.roamingSettings.get('showProxyWizard');
    const [showWizard, setShowWizard] = useState(officeSettingShow === false ? false : true);

    const stepData = [
        {
            step: 1,
            title: <Trans i18nKey="outlook_wizard.step_1.title" />,
            text: <Trans i18nKey="outlook_wizard.step_1.text" />,
            image: Card
        },
        {
            step: 2,
            title: <Trans i18nKey="outlook_wizard.step_2.title" />,
            text: <Trans i18nKey="outlook_wizard.step_2.text" />,
            image: Lock
        }
    ];

    useEffect(() => {
        if (step > (stepData.length - 1)) {
            setShowWizard(true);

            // Set Office Storage Wizard cookie to false
            Office.context.roamingSettings.set('showProxyWizard', false);
            Office.context.roamingSettings.saveAsync(function(result) {
                if (result.status !== Office.AsyncResultStatus.Succeeded) {
                    console.error(`Action failed with message ${result.error.message}`);
                } else {
                    console.log(`Settings saved with status: ${result.status}`);
                }
            });
        }
    }, [step]);
  
    return (
        <>
        { (showWizard && stepData[step]) && 
            <OutlookWizardStep 
                title={stepData[step].title}
                text={stepData[step].text}
                image={stepData[step].image}
                cb={() => { setStep(step + 1) }}
                />
        }
        </>
    );
}

export default withTranslation()(OutlookWizard);

function OutlookWizardStep(props) {

    const { title, text, image, cb} = props;

    const handleCallback = () => { if(cb) cb(); }

    return (
        <div className="outlook-wizard">
            {/* <div className="outlook-wizard__logo">
                <img src={OfficebookingLogo} alt='Officebooking logo'/>
            </div> */}
            <div className="outlook-wizard__graphic">
                <img src={image} alt='Lock'/>
            </div>
            <div className="outlook-wizard__text-container mb-5">
                <h3>{title}</h3>
                <p>{text}</p>
            </div>
            <button className="btn btn-primary btn-lg mt-5 mb-3 px-5 w-100" onClick={handleCallback}>
                <Trans i18nKey="continue" />
            </button>

            <div className="outlook-wizard__language-switch"><LanguageSwitch /></div>
        </div>
    );
}
